// Generated by scripts/build-ui-icons.mjs.
export { CaretDoubleRight as default } from "../ui/glyphs-2";
